export const initialState = {
  isLoading: {
    allUsers: false,
    allUsersModal: false,
    user: false,
  },
  allUsers: [],
  user: {
    document_id: "",
    first_name: "",
    last_name: "",
    email: "",
    department: "",
    position: "",
    phone: "",
    img_url: "",
    password: "",
    created_date: "",
    last_login_date: "",
    has_e_signature: "",
    e_signature_img_url: "",
    status: "active",
    role_list: [],
  },
  error: null,
};
